import http from 'plugins/axios';

export default {
  getOtcAuditList(data) {
    return http.get({
      url: '/la/admin/otc/list',
      data
    });
  },
  getSwitchStatue(data) {
    return http.get({
      url: '/la/admin/otc/switchStatue',
      data
    });
  },
  setSwitchStatue(data) {
    return http.post({
      url: '/la/admin/otc/switch',
      data,
      dataType: 'form'
    });
  },

  otcAudit(data) {
    return http.post({
      url: '/la/admin/otc/audit',
      data,
      dataType: 'form'
    });
  }
};
